import React from "react";
import { Box, Heading, Text } from "@chakra-ui/react";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";

export default function MasterSheets() {
  return (
    <Box pt={{ base: "120px", md: "75px" }} px={4}>
      <Card>
        <CardBody>
          <Heading size="md" mb={2}>
            Master Sheets
          </Heading>
          <Text color="gray.500">Master sheets management coming soon.</Text>
        </CardBody>
      </Card>
    </Box>
  );
}